import { AlertTriangle } from "lucide-react";
// Build 1 fix (session 60) — shared pending-extraction review banner.
// Surfaces an unconfirmed AI extraction (confirmBeforeSaving path) with
// Discard / Review actions. Extracted from GenericCategoryPage's card-branch
// banner so the card AND expandable layouts can both render it (they are
// mutually exclusive per section, so no double-render). The confirm modal it
// triggers already renders at page level.

export interface PendingExtractionSummary {
  fieldsFilled: number;
  documentName: string;
}

interface PendingExtractionBannerProps {
  pending: PendingExtractionSummary;
  onReview: () => void;
  onDiscard: () => void;
}

export function PendingExtractionBanner({ pending, onReview, onDiscard }: PendingExtractionBannerProps) {
  return (
    <div
      className="px-4 py-3 border-b text-sm flex items-start justify-between gap-3"
      style={{ backgroundColor: "#FFFBEB", borderColor: "#D69E2E" }}
    >
      <div className="flex-1">
        <p className="text-xs font-semibold text-amber-700 mb-0.5">
          <AlertTriangle className="h-4 w-4 inline-block shrink-0 align-[-2px]" aria-hidden="true" /> {pending.fieldsFilled} field{pending.fieldsFilled !== 1 ? "s" : ""} extracted from {pending.documentName} — review before saving
        </p>
      </div>
      <div className="flex gap-2 shrink-0">
        <button
          className="text-xs text-muted-foreground hover:text-foreground underline"
          onClick={onDiscard}
        >
          Discard
        </button>
        <button
          className="text-xs font-medium text-amber-700 hover:text-amber-900 underline"
          onClick={onReview}
        >
          Review &amp; save
        </button>
      </div>
    </div>
  );
}
